/*
    This is the web-included JS file for electron operations
    of Cabri3D.
    See desktop-bridge-web.js (under registerFunction) to see how
    this is embedded.
 */

function registerAPI() {

  console.log("... Registering web API as we are running in Electron.");

  bridge.registerFunction("fileLoad",function(filepath, content) {
    //let filepath = args[0], content = args[1];
    cabri.filepath = filepath;
    console.log(`Loading file ${filepath}.`);
    let p = new Parser(content, {"source": "content-in-url"});
    p.parse().then(()=>{
      window.cabri.objects = p.objects;
      window.cabri.document;
    }).catch((err)=> {console.log("Error " + err);})
  });

  bridge.registerFunction("close", () => {
    console.log("Closing.");
  });

  bridge.registerFunction("filePathChanged", (filepathOld, filepathNew) => {
    cabri.filepath = filepathNew;
  });

  bridge.registerFunction("fileSaved", () =>{
    cabri.fileDirty = false;
  });
  bridge.registerFunction("fileSave", () =>{
    cabri.saveFile();
  });

  bridge.registerFunction("consoleLog", (msg) =>  {console.log(msg)})

  bridge.consoleLog("Registered bridge functions.");
}

export {registerAPI};